/** Matches the backend's `FeedbackCategory` enum (native Postgres enum, serialized as its ordinal). */
export enum FeedbackCategory {
    BUG = 0,
    FEATURE_REQUEST = 1,
    IMPROVEMENT = 2,
    QUESTION = 3,
    GENERAL = 4
}

/** Matches the backend's `FeedbackStatus` enum. `New -> InReview -> {Resolved | Closed}`. */
export enum FeedbackStatus {
    NEW = 0,
    IN_REVIEW = 1,
    RESOLVED = 2,
    CLOSED = 3
}

/** Role bucket the submitter/assignee belongs to. Mirrors `QuestionRole` (see questions.enum.ts). */
export enum FeedbackRole {
    ADMIN = 0,
    WEALTH_MANAGER = 1,
    RELATIONSHIP_MANAGER = 2,
    CLIENT = 3
}
